angular.module("app").controller("SkinGamesListPageController", [
    '$scope',
    'pagination',
    '$timeout',
    'casinoGameService',
    'errorHandler',
    'logger',
    'preloadedProviders',
    'preloadedSkins',
    'settingsService',
    '$uibModal',
    'casinoJackpot',
    'userStorage',
    '$rootScope',
    'casinoCategoryService',
    function ($scope, pagination, $timeout, casinoGameService, errorHandler, logger, preloadedProviders, preloadedSkins, settingsService, $modal, casinoJackpot, userStorage, $rootScope, casinoCategoryService) {
        var pendingListRequest,
            initialDataForGames = [];

        $scope.jackpot = angular.copy(casinoJackpot);
        $scope.jackpot.unshift({
            key: "All",
            value: ""
        });
        $scope.skins = angular.copy(preloadedSkins);
        $scope.skipGamesLoad = false
        $scope.skins.unshift({
            "id": "",
            "name": "Select Skin"
        });
        var hasPermission = userStorage.getUserData().permissions.indexOf('manageAllSkinGames') !== -1;
        $scope.tabOptions = {};
        $scope.filterOptions = {
            status: 'all',
            bmeStatus: 'all',
            skinId: $scope.skins[0].id,
            jackpot: $scope.jackpot[0].value,
            search: "",
            searchByExternalId: "",
            gameType: "all",
            visibilityType: "all",
            showUnapproved: false
        };
        var oldStatus;

        $scope.labelColumnContainer= {
            column: "name",
            field: "label"
        };
        if (angular.isDefined($scope.filterOptions.is_mobile)) {
            $scope.filterOptions.gameType = $scope.filterOptions.is_mobile == 1 ? 'mobile' : 'desktop';
        } else {
            $scope.filterOptions.gameType = 'all'
        }
        $scope.multiSelect = {};
        $scope.multiSelect.categories = [];
        $scope.multiSelect.selectedCategories = [];
        $scope.multiSelect.providers = preloadedProviders;
        $scope.multiSelect.selectedProviders = [];


        $scope.getProviderFullName = function (key) {
            for (var i = 0, length = $scope.multiSelect.providers.length; i < length; i++) {
                if ($scope.multiSelect.providers[i].name === key) {
                    return $scope.multiSelect.providers[i].title;
                }
            }
        };
        
        function extractGame(game) {
            game.categories =  game.categories.reduce(function (prev, curr) {
                if (prev === "") {
                    return prev + curr.title;
                } else {
                    return prev + ", " + curr.title;
                }
            }, "");
            if (game.categories === ""){
                game.categories = "Not selected";
            }
            var image;

            switch (true) {
                case game.game.icon_2 !== undefined:
                    image = game.game.icon_2;
                    break;
                case game.game.icon_3 !== undefined:
                    image = game.game.icon_3;
                    break;
                case game.game.background !== undefined:
                    image = game.game.background;
                    break;
                case game.game.icon_1 !== undefined:
                    image = game.game.icon_1;
                    break;
                default:
                    image = undefined;
            }

            return {
                name: game.game.name,
                label: game.badge,
                images: image,
                order: game.order > 0 ? game.order : 'AI',
                is_mobile: game.game.is_mobile == 1 ? 'Mobile' : "Web",
                categories: game.categories,
                provider: game.game.provider_title || 'Not selected',
                disabled: game.disabled? 'Yes': 'No',
                created_at: game["created_at"],
                active: game.active,
                id: game.game.id,
                gameSkinId: game.gameSkinId
            }
        }
        $scope.games = [];
        $scope.pagination = pagination.init(function (resetPage, skinChange) {
            !!pendingListRequest && $timeout.cancel(pendingListRequest);
            pendingListRequest = $timeout(function () {
                if (skinChange) {
                    if ( $scope.filterOptions.showUnapproved) {
                        $scope.filterOptions.showUnapproved = false;
                        $scope.filterOptions.status= oldStatus || 'all';
                    }

                }
                var requestData = getFiltersValues();
                requestData.current_page =  $scope.pagination.page;
                resetPage === true && (requestData.current_page = 1);
                updateList(requestData, skinChange)
            }, 300);
        }, 0);

        $scope.editGame = function (game) {
            $modal.open({
                templateUrl: "views/skinGames/edit.html",
                controller: "SkinGamesEditPageController",
                resolve: {
                    currencies: function(resourcesService) {
                        return resourcesService.getResource("currencies.json").then(function (data) {
                            return angular.copy(data);
                        },function (response) {
                            return [];
                        });
                    },
                    preloadedGameData: function (casinoGameService, errorHandler) {
                        return casinoGameService.getSkinGames({gameSkinId: game.gameSkinId}).then(
                            function (response) {
                                if (response.status === "ok") {
                                    return angular.copy(response.skinGame)
                                } else {
                                    errorHandler(response.message);
                                    return {}
                                }
                            },
                            function (response) {
                                errorHandler(response.message);
                                return {}
                            }
                        )
                    },
                    preloadedCategories: function (casinoCategoryService, pageStatuses, errorHandler) {
                        return casinoCategoryService.get({status: pageStatuses[0], type: "category", skin_id: $scope.filterOptions.skinId}).then(
                            function (response) {
                                if (response.status === "ok") {
                                    return angular.copy(response.categories)
                                } else {
                                    errorHandler(response.message);
                                    return {}
                                }
                            },
                            function (response) {
                                errorHandler(response.message);
                                return {}
                            }
                        )
                    },
                    preloadedProviders: function (casinoProviderService, pageStatuses, errorHandler) {
                        return casinoProviderService.get({status: pageStatuses[0]}).then(
                            function (response) {
                                if (response.status === "ok") {
                                    return angular.copy(response.providers)
                                } else {
                                    errorHandler(response.message);
                                    return {}
                                }
                            },
                            function (response) {
                                errorHandler(response.message);
                                return {}
                            }
                        )
                    },
                    isLicense: function (){
                        return $scope.skins.filter(function (item){
                            return item.id === $scope.filterOptions.skinId
                        })[0].use_game_license_image;
                    },
                    hasCasinoBetLimits: function (){
                        return $scope.skins.filter(function (item){
                            return item.id === $scope.filterOptions.skinId
                        })[0].has_casino_bet_limits ;
                    },
                    hasCasinoRegulationInfo: function (){
                        return $scope.skins.filter(function (item){
                            return item.id === $scope.filterOptions.skinId
                        })[0].has_casino_regulation_info ;
                    },
                    casinoImageType: function (){
                        return $scope.skins.filter(function (item){
                            return item.id === $scope.filterOptions.skinId
                        })[0].casino_image_type;
                    }
                }
            }).result.then(function () {
                var requestData = getFiltersValues();
                requestData.current_page =  $scope.pagination.page;
                updateList(requestData);
            });
        };

        $scope.onFilterSelect
            = $scope.onFilterDeselect
            = $scope.onFilterSelectAll
            = $scope.onFilterDeselectAll
            = function () {
            return $scope.pagination.changePage()
        };

        $scope.toggleGameActivity = function (gameData, action) {
            var requestData = {
                skinGame: {
                    id: gameData.gameSkinId,
                    active: action
                }
            };
            casinoGameService.editSkinGameFull(requestData).then(
                function (response) {
                    if (response.status == "ok") {
                        if ($scope.filterOptions.showUnapproved) {
                            casinoGameService.getUnapprovedGamesCount({skinId: $scope.filterOptions.skinId}).then(function (res){
                                $scope.unapprovedGamesCount = res.count;
                                if ($scope.unapprovedGamesCount === 0) {
                                    $scope.filterOptions.showUnapproved = false;
                                    $scope.changeUnplayedAmount();
                                }
                                $scope.filterOptions.status !== 'all' && spliceFromList(gameData);
                                logger.logSuccess(action ? "global.activated" : "global.disabled");
                            });
                        } else{
                            $scope.filterOptions.status !== 'all' && spliceFromList(gameData);
                            logger.logSuccess(action ? "global.activated" : "global.disabled");
                        }

                    } else {
                        errorHandler(response.message);
                    }
                },
                function (response) {
                    errorHandler(response.message);
                }
            )
        };

        if (hasPermission) {
            $scope.tools = {
                edit: {
                    action: function (item) {
                        $scope.editGame(item);
                    },
                    title: function () {
                        return 'Edit';
                    },
                    class: function (){
                        return "";
                    }

                },
                "switch": {
                    name: function () {
                        return 'active';
                    },
                    model: function () {
                        return "active";
                    },
                    change: function (item) {
                        item.active ? $scope.toggleGameActivity(item, true) :  $scope.toggleGameActivity(item, false);
                    },
                    "class":function (){
                        return $scope.filterOptions.showUnapproved?"orange-passive":"";
                    }
                }
            };
        }



        function spliceFromList(game) {
            var index = $scope.games.indexOf(game);
            if (index != -1) {
                $scope.games.splice(index, 1);
            }
        }

        function updateList(requestOptions, skinChange) {
            settingsService.setFilters(requestOptions);
            if (!requestOptions.skinId  || $scope.skipGamesLoad) {
               $scope.skipGamesLoad = false
               return;
            }

            if (skinChange) {
                var skinUnapprovedRequest = {
                    skinId: requestOptions.skinId
                };
                casinoGameService.getUnapprovedGamesCount(skinUnapprovedRequest).then(function (res){
                    if (requestOptions.skinId === skinUnapprovedRequest.skinId) {
                        $scope.unapprovedGamesCount = res.count;
                    }
                });

                casinoCategoryService.get({status: "published", type: "category", skin_id: requestOptions.skinId}).then(
                    function (response) {
                        if (response.status === "ok") {
                            $scope.multiSelect.categories = angular.copy(response.categories)
                            $scope.skipGamesLoad = true
                        } else {
                            errorHandler(response.message);
                        }
                    }
                )
            }

            casinoGameService.getSkinGames(requestOptions).then(
                function (response) {
                    if (response.status === "ok") {
                        initialDataForGames = angular.copy(response.skinGames);
                        $scope.games = angular.copy(response.skinGames).map(extractGame);
                        $scope.pagination.totalItems = response.total_count;
                        $scope.pagination.page = requestOptions.current_page ? requestOptions.current_page : $scope.pagination.page;
                        $scope.discardChanges();
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        }
        if (hasPermission) {
            $scope.allowUpdateContainer = {};
            $scope.allowUpdateContainer.allowUpdate = function (options) {
                if (options && options.autoUpdate) {
                    reorder();
                } else if (!!options) {
                    $scope.tabOptions.reordered = true
                }
            };
        }
        var getPage = function(resetPage) {
            var requestData = getFiltersValues();
            requestData.current_page =  $scope.pagination.page;
            requestData.limit = $scope.pagination.limit;
            resetPage && (requestData.current_page = 1);
            updateList(requestData);
        };

        function saveOrdering(requestData) {
            casinoGameService.changeOrderSkinGames(requestData).then(
                function (response) {
                    if (response.status === "ok") {
                        logger.logSuccess("global.updated");
                        if(!requestData.drop) {
                            getPage();
                        }
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        }

        function reorder () {
            if (typeof $scope.games === "object" && $scope.games.length) {
                var list = [],
                    orders = [];

                $scope.games.forEach(function (item) {
                    if (item.order === 'AI') {
                        return;
                    }

                    list.push(item.gameSkinId);
                });

                initialDataForGames.forEach(function (item, index) {
                    if (item.order < 1) {
                        return;
                    }

                    $scope.games[index].order = item.order;
                    if ($scope.games[index].model) {
                        $scope.games[index].model.order = item.order;
                    }
                    initialDataForGames[index].order = item.order;
                    orders.push(item.order);
                });
                writtenOrders = {};

                saveOrdering({ids: list, orders: orders, drop: true});
            }
        }

        function getFiltersValues() {
            var categories = [],
                providers = [],
                filtersData = {},
                isActive = (($scope.filterOptions.status === 'active') || (($scope.filterOptions.status === 'all') ? undefined : false)),
                isDisabledFromBme = (($scope.filterOptions.bmeStatus === 'disabledFromBme') || (($scope.filterOptions.bmeStatus === 'all') ? undefined : false));

            filtersData.current_page = $scope.pagination.page;
            filtersData.limit = $scope.pagination.limit;
            filtersData.categories = $scope.multiSelect.selectedCategories;
            filtersData.providers = $scope.multiSelect.selectedProviders;
            filtersData.skinId = $scope.filterOptions.skinId;
            filtersData.search = $scope.filterOptions.search;
            filtersData.external_game_id = $scope.filterOptions.searchByExternalId;
            filtersData.is_mobile = ($scope.filterOptions.gameType == 'mobile' ? 1 : ($scope.filterOptions.gameType == 'desktop' ? 0 : undefined));
            filtersData.is_visible = ($scope.filterOptions.visibilityType === 'visible' ? 1 : ($scope.filterOptions.visibilityType === 'not-visible' ? 0 : undefined));
            filtersData.jackpot = $scope.filterOptions.jackpot !== $scope.jackpot[0].value ? $scope.filterOptions.jackpot : undefined;
            !filtersData.jackpot && (delete filtersData.jackpot);
            (filtersData.is_mobile === undefined) && (delete filtersData.is_mobile);
            (filtersData.is_visible === undefined) && (delete  filtersData.is_visible);
            !filtersData.search && (delete filtersData.search);
            !filtersData.external_game_id && (delete filtersData.searchByExternalId);

            if ($scope.filterOptions.showUnapproved) {
                filtersData.not_approved = 1;
            }

            angular.isDefined(isActive) && (filtersData.active = isActive);
            angular.isDefined(isDisabledFromBme) && (filtersData.disabled = isDisabledFromBme);

            return filtersData
        }

        $scope.listFilterObject = {
            action: function () {
                var requestData = getFiltersValues();
                updateList(requestData)
            }
        };

        $scope.ignoreColumns = {
            active: true,
            id: true,
            gameSkinId: true,
            model: true,
            label: true,
        };


        /**
         * Check is given string contains natural number
         * @param n string containing number
         * @returns {boolean}
         */
        function isNaturalNumber(n) {
            n = n.toString(); // force the value incase it is not
            var n1 = Math.abs(n),
                n2 = parseInt(n, 10);
            return !isNaN(n1) && n2 === n1 && n1.toString() === n;
        }


        $scope.saveOrdering = function () {
            var gamesLength = $scope.games.length;
            var requestOrders = {};
            var i = 0;
            for(var j = 0; j < gamesLength; ++j){
                var row = $scope.games[j];

                if (row.model.order === 'AI') {
                    continue;
                }

                if (!isNaturalNumber(row.model.order)) {
                    logger.logError("global.orderMustBeNaturalNumber");
                    return;
                }
                if(row.model.order !== row.order) {
                    requestOrders[i] = {
                        id: row.gameSkinId,
                        initialOrder: row.order,
                        newOrder: row.model.order
                    };
                    ++i;
                }

            }
            if (_.isEmpty(requestOrders)) {
                logger.logError("global.no_changes");
                return;
            }
            saveOrdering({orders:requestOrders});
        };

        $scope.tableIsInEditMode = false;
        /**
         * Table edit orders function
         */
        $scope.editTable = function () {
            if ($scope.tableIsInEditMode){
                return;
            }
            $scope.tableIsInEditMode = true;
            var tables = {
                "name": {type: 'empty'},
                "images": {type: 'empty'},
                "order": {type: "order"},
                "is_mobile": {type: 'empty'},
                "categories": {type: 'empty'},
                "provider": {type: 'empty'},
                "disabled": {type: 'empty'},
                "created_at": {type: 'empty'}
            };
            var gamesLength = $scope.games.length;
            for(var i = 0; i < gamesLength; ++i){
                var row = $scope.games[i];
                row.model = {};
                for(var key in row){
                    if (row.hasOwnProperty(key) && tables[key] !== undefined && tables[key].type !== 'empty') {
                        $scope.games[i].model[key] =  row[key];
                    }
                }
            }
            $scope.updateRow = tables;
            $rootScope.broadcast('changeToEditMode', true);
        };
        /**
         * Discard table changes
         */
        $scope.discardChanges = function discardChanges() {
            if ($scope.tableIsInEditMode) {
                writtenOrders = {};
                $scope.tableIsInEditMode = false;
                $rootScope.broadcast('changeToEditMode', false);
            }
        };

        /**
         * Check is order changed
         */
        $scope.checkForChanges = function checkForChanges() {
            if($scope.tableIsInEditMode) {
                var gamesLength = $scope.games.length;
                for(var j = 0; j < gamesLength; ++j) {
                    var row = $scope.games[j];
                    if(row.model.order !== row.order) {
                        return true;
                    }
                }
                return false;
            }
            return true;
        };

        $scope.changeUnplayedAmount = function changeUnplayedAmount() {
            $scope.pagination.page = 1;
            if ($scope.filterOptions.showUnapproved) {
                oldStatus = $scope.filterOptions.status;
                $scope.filterOptions.status = "inactive"
            } else {
                $scope.filterOptions.status= oldStatus || 'all';
            }
            $scope.pagination.changePage(true);
        };

        var writtenOrders = {};
        $scope.onBlurContainer =  {
            action: function (row) {
                if (writtenOrders[row.model.order] !== undefined) {
                    row.model.order = row.order;
                } else {
                    writtenOrders[row.model.order] = 1;
                }
            }
        };
        
    }
]);
